export default "__VITE_ASSET__FJlgwemO__"